/**
 * Return-path preservation through sign-in (simplified from
 * web/src/auth/returnPath.ts; the admin console has no checkout intent).
 */
import { sanitizeReturnPath } from '@/lib/redirect';

export interface ReturnIntent {
  /** Validated same-origin return path, or null. */
  returnPath: string | null;
}

export function parseReturnIntent(search: URLSearchParams | string | undefined): ReturnIntent {
  const params =
    typeof search === 'string' ? new URLSearchParams(search) : (search ?? new URLSearchParams());

  const redirect = params.get('redirect');
  const returnPath = redirect ? sanitizeReturnPath(redirect) : null;

  return { returnPath };
}
